import '.ae{border-radius:1.25rem;}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.hb{border:var(--border-default);}.ssr-plugin'
import '.hc{min-height:420px;}.ssr-plugin'
import '.bf{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.hd{color:var(--content-secondary);}.ssr-plugin'
import '.he{font-size:14px;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

const ALLOWED_EMBED_HOSTS = new Set([
  'www.slideshare.net',
  'slideshare.net',
  'www.youtube.com',
  'youtube.com',
  'player.vimeo.com',
  'vimeo.com',
  'docs.google.com',
])

function isAllowedEmbedUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url)
    return ALLOWED_EMBED_HOSTS.has(hostname)
  } catch {
    return false
  }
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  if (!isAllowedEmbedUrl(src)) {
    return (
      <styled.div className={`${className} ae ag hb hc bf a c i`}
        style={{
          ...style,
        }}
      >
        <p className="hd he">
          Embed URL not allowed.
        </p>
      </styled.div>
    )
  }

  return (
    <styled.div className={`${className} ae ag hb hc bf a b`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        sandbox="allow-scripts allow-same-origin allow-presentation"
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
